/** What someone did on the pre-drawn login.html before the app took over (issue #8). */
export interface Predrawn {
  number: string;
  focused: boolean;
}

let watched: { input: HTMLInputElement; focused: boolean } | null = null;

/**
 * At start-up, before the app draws: follow the pre-drawn number field until
 * the app replaces it. A page with no pre-drawn form has nothing to follow.
 */
export function watchPredrawn(doc: Document = document): void {
  const input = doc.querySelector<HTMLInputElement>('form[data-predrawn] input');
  if (!input) return;
  const state = { input, focused: doc.activeElement === input };
  watched = state;
  input.addEventListener('focus', () => {
    state.focused = true;
  });
  // Chrome blurs the field while the takeover removes it, still connected at that
  // moment: a blur only counts if the field is on the page once it has settled.
  input.addEventListener('blur', () => {
    queueMicrotask(() => {
      if (input.isConnected) state.focused = false;
    });
  });
}

/** What the pre-drawn form held when the app took over: given once, then null. */
export function takePredrawn(): Predrawn | null {
  const taken = watched;
  watched = null;
  // The field itself, even out of the page: it has whatever was typed or autofilled.
  return taken ? { number: taken.input.value, focused: taken.focused } : null;
}
